import { observer } from 'mobx-react';
import React, {Fragment} from "react";
import { Link } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, Label, Media, Row, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Mail, PhoneCall, Phone } from "react-feather";
import profileImg from "../../../assets/img/profile/placeholder.svg";
import "../../../assets/scss/pages/users.scss";
import ICustomer from "../../../types/ICustomer";
import Avatar from "../../elements/avatar";
import classnames from "classnames";
import Accordion from '../../../theme/reactstrap/collapse/Accordion';

import "../../../assets/scss/pages/common.scss";
import InputText from '../../common/InputText';

interface ICustomerAccountTabProps {
  customer: ICustomer,
  onChangeText: Function,
  onBooleanChange: Function,
  onSave: Function,
  onSaveImage: Function,
  errors: any
}

interface ICustomerAccountTabState {
  dropdownOpen: boolean,
  dropdownIcon: boolean,
  dropdownRight: boolean,
  avatarEditVisible: boolean
}

@observer
class CustomerAccountTab extends React.Component<ICustomerAccountTabProps, ICustomerAccountTabState> {
  state = {
    avatarEditVisible: false,
    dropdownOpen: false,
    dropdownIcon: false,
    dropdownRight: false
  }

  toggleDropDown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    })
  }

  toggleSlider = (bool: boolean) => {
    this.setState({
      avatarEditVisible: bool
    })
  }

  render(){
    const { customer, onChangeText, onBooleanChange, onSave, errors } = this.props;
    const { account } = customer;
    return (
      <Fragment>
        <Row>
          <Col sm="12">
            <Media className="mb-2">
              <Media className="mt-10 mr-2 my-25" left href="#">
                <Media
                  className="rounded"
                  object
                  src={account.image ? account.image : profileImg }
                  alt="user profile image"
                  height="110"
                  width="95"
                />
              </Media>
              <Media className="mt-2" body>
                <Media className="font-medium-1 text-bold-600" tag="p" heading>
                  {account.title+" "+account.firstName+" "+account.lastName}
                </Media>
                <div className="d-flex flex-wrap">
                  <Button 
                    onClick={() => { this.toggleSlider(true)}} 
                    className="mr-50 cursor-pointer"
                    color="primary"
                    outline>
                    Change Avatar
                  </Button>
                  <Button color="flat-danger">Remove Avatar</Button>
                </div>
                <p className="text-muted mt-50">
                  <small>Allowed JPG, GIF or PNG. Max size of 800kB</small>
                </p>
              </Media>
            </Media>
          </Col>
          <Col sm="12">
            <Form onSubmit={e => {e.preventDefault(); onSave()}}>
              <Row>
                <Col md="4" sm="12">
                  <FormGroup>
                    <Label for="title" className="width-12 mr-10">Title</Label>
                      <Input type="select" name="title" id="title" defaultValue={account.title} onChange={(e) => onChangeText("account.title", e.target.value)} className="display-inline width-12 mr-10">
                        <option>Mr</option>
                        <option>Mrs</option>
                        <option>Miss</option>
                      </Input>
                  </FormGroup>
                  <InputText
                        type="text"
                        value={account.firstName}
                        onChange={(e) => onChangeText("account.firstName", e.target.value)}
                        id="firstName"
                        name="firstName"
                        placeholder="First Name"
                        label="First Name"
                        className="display-inline width-85"
                        error={errors['account.firstName']}
                  />
                  <InputText
                    type="text"
                    value={account.lastName}
                    onChange={(e) => onChangeText("account.lastName", e.target.value)}
                    id="lastName"
                    name="lastName"
                    placeholder="Last Name"
                    label="Last Name"
                    className="display-inline width-85"
                    error={errors['account.lastName']}
                  />
                  <InputText
                    type="text"
                    value={account.jobTitle}
                    onChange={(e) => onChangeText("account.jobTitle", e.target.value)}
                    id="jobTitle"
                    name="jobTitle"
                    placeholder="Job Title"
                    label="Job Title"
                    className="display-inline width-85"
                    error={errors['account.jobTitle']}
                  />
                  </Col>
                <Col md="4" sm="12">
                  <InputText
                    type="text"
                    value={account.email}
                    onChange={(e) => onChangeText("account.email", e.target.value)}
                    id="email"
                    name="email"
                    placeholder="Email"
                    label="Email"
                    className="display-inline width-85"
                    error={errors['account.email']}
                  />
                
                  <InputText
                    type="text"
                    value={account.company}
                    onChange={(e) => onChangeText("account.company", e.target.value)}
                    id="company"
                    name="company"
                    placeholder="Company"
                    label="Company"
                    className="display-inline width-85"
                    error={errors['account.company']}
                  />
                  <InputText
                    type="text"
                    value={account.departmentName}
                    onChange={(e) => onChangeText("account.departmentName", e.target.value)}
                    id="departmentName"
                    name="departmentName"
                    placeholder="Department Name"
                    label="DepartmentName"
                    className="display-inline width-85"
                    error={errors['account.departmentName']}
                  />
                  </Col>
                <Col md="4" sm="12">
                  <InputText
                    type="text"
                    value={account.phoneNumber}
                    onChange={(e) => onChangeText("account.phoneNumber", e.target.value)}
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    label="Phone Number"
                    className="display-inline width-85"
                    controlIcon={<PhoneCall size={20}/>}
                    error={errors['account.phoneNumber']}
                  />
                  <InputText
                    type="textarea"
                    rows={3}
                    value={account.additionalInfo}
                    onChange={(e) => onChangeText("account.additionalInfo", e.target.value)}
                    id="additionalInfo"
                    name="additionalInfo"
                    placeholder="Additional Info"
                    label="Additional Info"
                    className="display-inline width-85"
                    error={errors['account.additionalInfo']}
                  />
                  <FormGroup>
                    <div className="checkbox switcher">
                      <label htmlFor="active">
                        <input
                          type="checkbox"
                          id="active"
                          checked={account.status ? true : false}
                          name="active"
                          onChange={(e) => onBooleanChange("account.status", e.target.checked )}
                        />
                        <span><small></small></span>
                        <span>Active</span>
                      </label>
                    </div>
                  </FormGroup>
               </Col>
                
              </Row>
            </Form>
          </Col>
        </Row>
        <div className="animation-slider">
          {
            this.state.avatarEditVisible
              ? <Avatar 
                show={this.state.avatarEditVisible}
                onSave={this.props.onSaveImage}
                toggleSliderVisibility={()=>this.toggleSlider(false)}
              />
              : null
          }
          <div
            className={classnames("animation-slider-overlay", {
              show: this.state.avatarEditVisible
            })}
            onClick={() => this.toggleSlider(false)}
          />
        </div>  
      </Fragment>  
    )
   }
  }
  export default CustomerAccountTab;
